import React from 'react';
import PropTypes from 'prop-types';

import { SeoLink } from 'dibs-seo/exports/SeoLink';
import HpLazyImageWrapper from '../HpLazyImageWrapper/HpLazyImageWrapper';
import ResponsiveImage from '../ResponsiveImage';

import styles from './HpRespCollectionsModuleItemOld.scss';

function HpRespCollectionsModuleItemOld({ item, onClick, useLazyLoadImages }) {
    const { title, imageUrl, linkData } = item;

    return (
        <SeoLink
            linkData={linkData}
            className={styles.link}
            onClick={onClick}
            dataTn="collections-item-link"
        >
            <HpLazyImageWrapper useLazyLoad={useLazyLoadImages} className={styles.imageWrapper}>
                <ResponsiveImage
                    className={styles.image}
                    src={imageUrl}
                    altText={title}
                    dataTn="collections-item-image"
                    srcSetWidths={[120, 150]}
                />
            </HpLazyImageWrapper>
            <span className={styles.title} data-tn="collections-item-title">
                {title}
            </span>
        </SeoLink>
    );
}

HpRespCollectionsModuleItemOld.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        imageUrl: PropTypes.string,
        linkData: PropTypes.object.isRequired,
    }).isRequired,
    onClick: PropTypes.func,
    useLazyLoadImages: PropTypes.bool,
};

HpRespCollectionsModuleItemOld.defaultProps = {
    onClick: () => {},
};

export { HpRespCollectionsModuleItemOld };
